module.exports = __webpack_public_path__ + "media/images/endicott_7-22304505c60f6eede4175e2dad958b54.jpg";